var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExploreEngineering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.475,
    height: 70.826,
    viewBox: "0 0 62.475 70.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "engineering",
    transform: "translate(-30.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54178",
    "data-name": "Path 54178",
    d: "M79.183,286.018a17.748,17.748,0,0,1-35.5,0h-13.5v3.707a1.12,1.12,0,0,0,.9,1.109l6.278,1.215a24.657,24.657,0,0,0,2.786,6.721l-3.581,5.3a1.13,1.13,0,0,0,.137,1.431l5.242,5.242a1.13,1.13,0,0,0,1.432.137l5.3-3.581a24.656,24.656,0,0,0,6.721,2.786l1.215,6.279a1.13,1.13,0,0,0,1.109.915h7.413a1.13,1.13,0,0,0,1.109-.915l1.215-6.279a24.655,24.655,0,0,0,6.721-2.786l5.3,3.581a1.13,1.13,0,0,0,1.432-.137L86.16,305.5a1.13,1.13,0,0,0,.137-1.431l-3.582-5.3a24.657,24.657,0,0,0,2.786-6.721l6.278-1.215a1.1,1.1,0,0,0,.88-1.109v-3.707Z",
    transform: "translate(-0.001 -246.453)",
    fill: "#afb4bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54179",
    "data-name": "Path 54179",
    d: "M92.659,232.067H30.184v-5.931a2.721,2.721,0,0,1,2.719-2.73h57a2.755,2.755,0,0,1,2.76,2.73v5.931Z",
    transform: "translate(0 -192.502)",
    fill: "#ff8d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54180",
    "data-name": "Path 54180",
    d: "M89.9,223.407H81.831a2.73,2.73,0,0,1,2.73,2.73h0A2.763,2.763,0,0,1,81.8,228.9H30.184v3.169H92.659v-5.931A2.756,2.756,0,0,0,89.9,223.407Z",
    transform: "translate(0 -192.503)",
    fill: "#ff7610"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54181",
    "data-name": "Path 54181",
    d: "M90.47,38.795H87.529A25.316,25.316,0,0,0,62.213,64.111v.222h53.574v-.222A25.316,25.316,0,0,0,90.47,38.795Z",
    transform: "translate(-27.598 -33.428)",
    fill: "#ffdc48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54182",
    "data-name": "Path 54182",
    d: "M236.679,38.795h-2.5q-1.025,0-2.03.08a25.539,25.539,0,0,1,23.508,25.457h6.558A25.538,25.538,0,0,0,236.679,38.795Z",
    transform: "translate(-174.028 -33.428)",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54183",
    "data-name": "Path 54183",
    d: "M168.481,31.375l-1.773-5.8a1.227,1.227,0,0,1,1.173-1.585,50.023,50.023,0,0,1,22.223,0,1.277,1.277,0,0,1,.986.5,1.219,1.219,0,0,1,.187,1.088l-1.686,5.52Z",
    transform: "translate(-117.592 -19.592)",
    fill: "#ffb82e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54184",
    "data-name": "Path 54184",
    d: "M190,23.574l2.263,7.781,13.694-.243,2.263-7.537a49.959,49.959,0,0,0-18.22,0Z",
    transform: "translate(-137.706 -19.592)",
    fill: "#ffa910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54185",
    "data-name": "Path 54185",
    d: "M206.357,16.177V1.732A1.731,1.731,0,0,1,208.089,0H218.32a1.731,1.731,0,0,1,1.732,1.732V16.177Z",
    transform: "translate(-151.803)",
    fill: "#ffb82e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46630",
    "data-name": "Group 46630",
    transform: "translate(34.615 26.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54186",
    "data-name": "Path 54186",
    d: "M224.059,194.569H213.438v-3.341a1.288,1.288,0,0,1,1.288-1.288h8.044a1.288,1.288,0,0,1,1.288,1.288Z",
    transform: "translate(-192.519 -189.939)",
    fill: "#ff5122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54187",
    "data-name": "Path 54187",
    d: "M67.482,189.938h-4.85a25.681,25.681,0,0,0-.42,4.63h6.558v-3.341A1.289,1.289,0,0,0,67.482,189.938Z",
    transform: "translate(-62.213 -189.938)",
    fill: "#ff5122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54188",
    "data-name": "Path 54188",
    d: "M403.376,189.938h4.85a25.682,25.682,0,0,1,.42,4.63h-6.558v-3.341A1.289,1.289,0,0,1,403.376,189.938Z",
    transform: "translate(-355.072 -189.938)",
    fill: "#ff5122"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_54189",
    "data-name": "Path 54189",
    d: "M92.659,286.018H79.182a17.749,17.749,0,0,1-35.157,3.466h.032a17.831,17.831,0,0,1-.339-3.466H30.184v3.466h4.405a7.021,7.021,0,0,1,6.537,4.47,21.806,21.806,0,0,0,40.615,0,7.021,7.021,0,0,1,6.537-4.47h4.381v-3.466Z",
    transform: "translate(0 -246.453)",
    fill: "#808791"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreEngineering);
export default __webpack_public_path__ + "static/media/explore-engineering.551f4f959374064fbc60895e53e39807.svg";
export { ForwardRef as ReactComponent };